module.exports = __webpack_public_path__ + "media/images/flags/aw-ae72ffe382a0d6b6dc74946a647d9df6.svg";